/**
 * @jest-environment jsdom
 */

import '../table-chart';

describe('chart-el element', () => {
  it('Expect <echarts-table /> element is defined', () => {
    expect(customElements.get('echarts-table')).toBeDefined();
  });
});
